import React, { useState, useEffect, useContext } from 'react';
import { useAxios } from '../../utils/Axios';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Geohash from 'latlon-geohash'
import Layout from '../../components/Layout/Layout';
import AddUpdateUsers from '../../components/AddUpdateUsers/AddUpdateUsers';
import ExperimentTable from '../../components/ExperimentTable/ExperimentTable';
import ExperimentArchiveTable from '../../components/ExperimentTable/ExperimentArchiveTable';
import CreateExperiment from '../../components/Createexperiment/CreateExperiment';
import FilesTable from '../../components/Table/FilesTable'
import NetworkNodes from '../../components/NetworkMap/NetworkNodes';
import { ToastContainer, Zoom, toast } from 'react-toastify';

import Button from 'react-bootstrap/Button';
import ImageUploader from '../../components/UploadManager/ImageUploader'
import BinaryUploader from '../../components/UploadManager/BinaryUploader'
import './Project.css';
import ListIcon from '@mui/icons-material/List';

import Context from '../../store/Context'
import { Box, Breadcrumbs, Chip, Paper, Stack, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Link } from 'react-router-dom';
import { emphasize, styled } from '@mui/material/styles';
import FolderIcon from '@mui/icons-material/Folder';
import { TabContext, TabList, TabPanel } from '@mui/lab';

const Project = ({ match }) => {
	const [projectInfo, setProjectInfo] = useState([]);
	const [experiments, setExperiments] = useState([]);
	const [archiveExperiments, setArchiveExperiments] = useState([]);
	const [getImages, setImages] = useState([]);
	const [imgFileSeverity, setimgFileSeverity] = useState([])
	const [getBinaries, setBinaries] = useState([]);
	const [nodeList, setNodeList] = useState([]); // state to store network nodes list
	const [expNodes, setExpNodes] = useState([]); // state to store experiment nodes list
	const [filesList, setFilesList] = useState([]);
	const [imageManager, setImageManager] = useState(false);
	const [binaryManager, setBinaryManager] = useState(false);
	const [projectRole, setProjectRole] = useState(''); // code to store projectRole and use it for validation

	const [value, setValue] = React.useState('1');

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const axiosInstance = useAxios();

	const { state, actions } = useContext(Context);

	useEffect(() => {
		// setTimeout(() => {
		// 	fetchProject();
		// }, 200);
		fetchProject();
	}, [axiosInstance, match]);

	//Code to fetch Individual Project Details
	const fetchProject = () => {
		if (axiosInstance) {
			actions({ type: 'setState', payload: { ...state, blocking: true } })
			axiosInstance
				.get(`${process.env.REACT_APP_PROJECT_URL}/projects/${match.params.id}`)
				.then((response) => {
					setProjectInfo(response.data);
					// console.log(response.data)
					fetchNodes(response.data);
					fetchImages()
					setProjectRole(response.data.projectRole);
					localStorage.setItem('projectrole', response.data.projectRole)
				})
				.then(
					setTimeout(() => {
						// fetchImages()
					}, 1000)

				)
				.catch((err) => {
					// console.log(err);
					fetchNodes({ 'testBedName': '' })
					fetchImages();
				});

		}
	};

	//Code to fetch Experiments List
	const fetchExperiments = () => {
		if (axiosInstance)
			axiosInstance
				.get(`${process.env.REACT_APP_EXPERIMENT_URL}/projects/${match.params.id}/experiments`)
				.then((response) => {
					// setExperiments(response.data);

					experimentListSort(response.data);
					// console.log(response.data)
				})
				.catch((err) => {
					// console.log(err);
				});
	}

	//code to fetch Images and storing in State
	const fetchImages = () => {
		if (axiosInstance)
			// actions({type : 'setState', payload : {...state , blocking : true}})
			axiosInstance
				.get(`${process.env.REACT_APP_PROJECT_URL}/projects/${match.params.id}/images`)
				.then((response) => {
					setImages(response.data)
					checkImageStatus(response.data)
				})
				.then(
					setTimeout(() => {
						fetchBinaries()
					}, 500)
				)
				.catch((err) => {
					// console.log(err);
					fetchBinaries();
				});

	}

	//Code to fetch Binaries
	const fetchBinaries = () => {
		// alert()
		if (axiosInstance)
			axiosInstance
				.get(`${process.env.REACT_APP_PROJECT_URL}/projects/${match.params.id}/binaries`)
				.then((response) => {
					setBinaries(response.data);
					// console.log(projectInfo)
				})
				.catch((err) => {
					// console.log(err);
				});

		actions({ type: 'setState', payload: { ...state, blocking: false } })
	}

	//show Image Files upload 
	const onImageFileChange = (event) => {
		let imgTagId = document.getElementById('unImgUpload');
		imgTagId.style.display = 'block';

		let binTagId = document.getElementById('binImgUpload');
		binTagId.style.display = 'none';

		// setImageManager(true)
		// setBinaryManager(false)
	};

	//show Binary Files Upload 
	const onBinaryFileChange = (event) => {
		let imgTagId = document.getElementById('unImgUpload');
		imgTagId.style.display = 'none';

		let binTagId = document.getElementById('binImgUpload');
		binTagId.style.display = 'block';
		// setImageManager(false)
		// setBinaryManager(true)
	}

	//Code to fetch nodes based on network and passing to children
	const fetchNodes = (data) => {
		// console.log(data)
		let networkId = data.testBedName
		if (axiosInstance) {
			axiosInstance
				.get(`${process.env.REACT_APP_NODEMONITOR_URL}/node-networks/${networkId}`)
				.then((response) => {
					// console.log(response)
					setTimeout(() => {
						convertGeohash(response)
						// let data = response
						// let data = {data : {"nodeNetwork":{"name":"default"},"nodes":[{"hostName":"umbrella-0045516d","nodeType":"RSE","friendlyName":"RSE-A-20-C\n","gpsHash":"gcnjn050u89t","status":"InActive"},{"hostName":"umbrella-02146357","nodeType":"RSS","friendlyName":"RSS-A-12-C\n","gpsHash":"gcnjp26620hr","status":"Active"},{"hostName":"umbrella-026eff5f","nodeType":"RSS","friendlyName":"RSS-2-C\n","gpsHash":"gcnhypen75ey","status":"InActive"},{"hostName":"umbrella-02787a48","nodeType":"RSS","friendlyName":"RSS-14-C\n","gpsHash":"gcnhzx2f2ucq","status":"Active"},{"hostName":"umbrella-03006393","nodeType":"RSE","friendlyName":"RSE-2-C\n","gpsHash":"gcnhzx820x91","status":"Active"},{"hostName":"umbrella-044f56e6","nodeType":"RSE","friendlyName":"RSE-A-7-C\n","gpsHash":"gcnjn0m9uvdy","status":"InActive"},{"hostName":"umbrella-04c6c790","nodeType":"RSS","friendlyName":"RSS-56-C\n","gpsHash":"gcnhyzvb0pdb","status":"Active"},{"hostName":"umbrella-051d08ba","nodeType":"RSS","friendlyName":"RSS-19-C\n","gpsHash":"gcnhyzb6gym3","status":"Active"},{"hostName":"umbrella-059b13d6","nodeType":"RSS","friendlyName":"RSS-63-C\n","gpsHash":"gcnhyztjbw7d","status":"Active"},{"hostName":"umbrella-078c906a","nodeType":"RSS","friendlyName":"RSS-13-C\n","gpsHash":"gcnhzx1w32gr","status":"Active"},{"hostName":"umbrella-07a5626f","nodeType":"RSS","friendlyName":"RSS-A-19-C\n","gpsHash":"gcnhzx1r3nbd","status":"Active"},{"hostName":"umbrella-07b6a1c1","nodeType":"RSE","friendlyName":"RSE-A-15-C\n","gpsHash":"gcnjp2j5p7b2","status":"Active"},{"hostName":"umbrella-0b84127c","nodeType":"RSE","friendlyName":"RSE-A-24-C\n","gpsHash":"gcnhyp6ft1ve","status":"InActive"},{"hostName":"umbrella-0e008e4b","nodeType":"RSS","friendlyName":"RSS-22-C\n","gpsHash":"gcnhzx2jz8ju","status":"Active"},{"hostName":"umbrella-172045ab","nodeType":"RSS","friendlyName":"RSS-A-39-C\n","gpsHash":"gcnjn0q7hbgc","status":"InActive"},{"hostName":"umbrella-1a2dcc10","nodeType":"RSE","friendlyName":"RSE-L-A-1-C\n","gpsHash":"gcnhzrz05pzv","status":"Active"},{"hostName":"umbrella-1a5fcf7f","nodeType":"RSS","friendlyName":"RSS-A-45-C\n","gpsHash":"gcnjp24qdn75","status":"Active"},{"hostName":"umbrella-1b9ed7ba","nodeType":"RSS","friendlyName":"RSS-51-C\n","gpsHash":"gcnhzry3wbj0","status":"Active"},{"hostName":"umbrella-1bca2b78","nodeType":"RSS","friendlyName":"RSE-47-C\n","gpsHash":"gcnjp2huuxmy","status":"Active"},{"hostName":"umbrella-1ca5d162","nodeType":"RSE","friendlyName":"RSE-18-C\n","gpsHash":"s00000000000","status":"Active"},{"hostName":"umbrella-1d01c9bb","nodeType":"RSS","friendlyName":"RSS-47-C\n","gpsHash":"s00000000000","status":"Active"},{"hostName":"umbrella-1e221617","nodeType":"RSS","friendlyName":"RSS-43-C\n","gpsHash":"gcnjp20wjnp4","status":"Active"},{"hostName":"umbrella-1ffe9b9d","nodeType":"RSE","friendlyName":"RSE-25-C\n","gpsHash":"gcnjp0nj5x1x","status":"Active"},{"hostName":"umbrella-2082cf41","nodeType":"RSS","friendlyName":"RSS-20-C\n","gpsHash":"gcnhyxze8rz9","status":"Active"},{"hostName":"umbrella-2161cd48","nodeType":"RSE","friendlyName":"RSE-A-16-C\n","gpsHash":"gcnhyzsqrv6y","status":"Active"},{"hostName":"umbrella-2512be2d","nodeType":"RSS","friendlyName":"RSS-1-C\n","gpsHash":"gcnhyp7g5wbu","status":"InActive"},{"hostName":"umbrella-258de557","nodeType":"RSE","friendlyName":"RSE-19-C\n","gpsHash":"gcnjp21pcqxn","status":"Active"},{"hostName":"umbrella-29edd941","nodeType":"RSE","friendlyName":"RSE-24-C\n","gpsHash":"gcnjp05ddd6k","status":"Active"},{"hostName":"umbrella-2aeb82c5","nodeType":"RSE","friendlyName":"RSE-6-C\n","gpsHash":"gcnjn0rtq619","status":"Active"},{"hostName":"umbrella-2de5f6e6","nodeType":"RSE","friendlyName":"RSE-A-13-C\n","gpsHash":"gcnhyzeyeb3n","status":"Active"},{"hostName":"umbrella-31f87a36","nodeType":"RSS","friendlyName":"RSS-37-C\n","gpsHash":"s00000000000","status":"Active"},{"hostName":"umbrella-3ac7a885","nodeType":"RSS","friendlyName":"RSS-A-3-C\n","gpsHash":"gcnhyxuxcfqu","status":"Active"},{"hostName":"umbrella-4612d9c1","nodeType":"RSS","friendlyName":"RSS-A-5-C\n","gpsHash":"gcnjp21zxs82","status":"Active"},{"hostName":"umbrella-464a382f","nodeType":"RSS","friendlyName":"RSS-59-C\n","gpsHash":"gcnjp0ph957k","status":"Active"},{"hostName":"umbrella-49d1f5d9","nodeType":"RSS","friendlyName":"RSS-16-C\n","gpsHash":"gcnhzx2w3jfc","status":"Active"},{"hostName":"umbrella-4e736def","nodeType":"RSE","friendlyName":"RSE-A-4-C\n","gpsHash":"gcnjn8h4nzpv","status":"Active"},{"hostName":"umbrella-50eadfb5","nodeType":"RSE","friendlyName":"RSE-A-19-C\n","gpsHash":"gcnjp0pqsey3","status":"Active"},{"hostName":"umbrella-543733ea","nodeType":"RSS","friendlyName":"RSS-39-C\n","gpsHash":"gcnhzx4e6ycv","status":"Active"},{"hostName":"umbrella-54bb0948","nodeType":"RSE","friendlyName":"RSE-33-C\n","gpsHash":"gcnjp2hqn6mc","status":"Active"},{"hostName":"umbrella-56c2cbdd","nodeType":"RSS","friendlyName":"RSS-10-C\n","gpsHash":"gcnjn817s2kd","status":"Active"},{"hostName":"umbrella-577148fc","nodeType":"RSS","friendlyName":"RSS-A-8-C\n","gpsHash":"gcnjp0j4gvkf","status":"Active"},{"hostName":"umbrella-59497bcb","nodeType":"RSE","friendlyName":"RSE-49-C\n","gpsHash":"gcnjn856z4kd","status":"Active"},{"hostName":"umbrella-5d10de36","nodeType":"RSS","friendlyName":"RSS-A-7-C\n","gpsHash":"gcnjp25wdzf7","status":"Active"},{"hostName":"umbrella-5ece3e23","nodeType":"RSE","friendlyName":"RSE-46-C\n","gpsHash":"gcnhzx1zuc9n","status":"Active"},{"hostName":"umbrella-5f526b11","nodeType":"RSE","friendlyName":"RSE-L-7-C\n","gpsHash":"gcnhype2t06r","status":"InActive"},{"hostName":"umbrella-64c61e47","nodeType":"RSE","friendlyName":"RSE-A-11-C\n","gpsHash":"gcnjp23cnv33","status":"Active"},{"hostName":"umbrella-65162711","nodeType":"RSS","friendlyName":"RSS-60-C\n","gpsHash":"gcnhzrvx35fg","status":"Active"},{"hostName":"umbrella-752477ea","nodeType":"RSS","friendlyName":"RSS-A-29-C\n","gpsHash":"gcnhyzef88hr","status":"Active"},{"hostName":"umbrella-783bb75a","nodeType":"RSS","friendlyName":"RSS-32-C\n","gpsHash":"gcnhzrxjqesv","status":"Active"},{"hostName":"umbrella-7969439a","nodeType":"RSS","friendlyName":"RSS-A-38-C\n","gpsHash":"s00000000000","status":"InActive"},{"hostName":"umbrella-7bce80da","nodeType":"RSE","friendlyName":"RSE-20-C\n","gpsHash":"gcnhzx33c0gy","status":"Active"},{"hostName":"umbrella-7c4d444d","nodeType":"RSS","friendlyName":"RSS-23-C\n","gpsHash":"gcnjn26nsht1","status":"InActive"},{"hostName":"umbrella-7cf1a4e1","nodeType":"RSE","friendlyName":"RSE-L-A-8-C\n","gpsHash":"gcnhzx4mt2s3","status":"Active"},{"hostName":"umbrella-7d2b629c","nodeType":"RSE","friendlyName":"RSE-L-1-C\n","gpsHash":"gcnhzpbqzpd5","status":"Active"},{"hostName":"umbrella-7d314e6c","nodeType":"RSS","friendlyName":"RSS-A-18-C\n","gpsHash":"gcnhzx44w7s8","status":"Active"},{"hostName":"umbrella-89be7b49","nodeType":"RSE","friendlyName":"RSE-15-C\n","gpsHash":"gcnhzrxeww53","status":"Active"},{"hostName":"umbrella-89f88754","nodeType":"RSE","friendlyName":"RSE-29-C\n","gpsHash":"gcnhyzbgst5j","status":"Active"},{"hostName":"umbrella-8babc88d","nodeType":"RSS","friendlyName":"RSS-A-26-C\n","gpsHash":"gcnhzx1xh11v","status":"Active"},{"hostName":"umbrella-8fe79cc0","nodeType":"RSE","friendlyName":"RSE-44-C\n","gpsHash":"gcnhzrykpmkm","status":"Active"},{"hostName":"umbrella-907475e1","nodeType":"RSE","friendlyName":"RSE-21-C\n","gpsHash":"gcnjp20prn72","status":"Active"},{"hostName":"umbrella-95faab66","nodeType":"RSE","friendlyName":"RSE-A-8-C\n","gpsHash":"gcnhypg09ndc","status":"InActive"},{"hostName":"umbrella-9af49aa5","nodeType":"RSE","friendlyName":"RSE-A-21-C\n","gpsHash":"gcnjp2j8zfxe","status":"Active"},{"hostName":"umbrella-a1e0db1e","nodeType":"RSS","friendlyName":"RSS-6-C\n","gpsHash":"gcnhypfupfsb","status":"InActive"},{"hostName":"umbrella-a235fa19","nodeType":"RSE","friendlyName":"RSE-31-C\n","gpsHash":"gcnhyzv95p77","status":"Active"},{"hostName":"umbrella-a4117178","nodeType":"RSS","friendlyName":"RSS-8-C\n","gpsHash":"gcnjp21x7p9m","status":"Active"},{"hostName":"umbrella-a59ae9b1","nodeType":"RSS","friendlyName":"RSS-46-C\n","gpsHash":"gcnhzx4n9sx1","status":"Active"},{"hostName":"umbrella-af753e93","nodeType":"RSS","friendlyName":"RSS-A-28-C\n","gpsHash":"gcnhyp7kt5t5","status":"InActive"},{"hostName":"umbrella-b14254cd","nodeType":"RSS","friendlyName":"RSS-33-C\n","gpsHash":"gcnjp0h1u96d","status":"Active"},{"hostName":"umbrella-b54e8e4f","nodeType":"RSE","friendlyName":"RSE-27-C\n","gpsHash":"gcnhyzzmz2zj","status":"Active"},{"hostName":"umbrella-bf5230a6","nodeType":"RSE","friendlyName":"RSE-34-C\n","gpsHash":"gcnjp27b2f26","status":"Active"},{"hostName":"umbrella-c092d456","nodeType":"RSE","friendlyName":"RSE-23-C\n","gpsHash":"gcnjp0184wcs","status":"Active"},{"hostName":"umbrella-c54af161","nodeType":"RSS","friendlyName":"RSS-A-21-C\n","gpsHash":"gcnhzrxc6jsw","status":"Active"},{"hostName":"umbrella-d1d9fd2a","nodeType":"RSS","friendlyName":"RSS-29-C\n","gpsHash":"gcnhzpbj3b0w","status":"Active"},{"hostName":"umbrella-d21deffd","nodeType":"RSS","friendlyName":"RSS-5-C\n","gpsHash":"gcnjn0kbrn3z","status":"InActive"},{"hostName":"umbrella-d4a5c9a8","nodeType":"RSS","friendlyName":"RSE-26-C\n","gpsHash":"gcnhyxyqzjdb","status":"Active"},{"hostName":"umbrella-d4ae80e4","nodeType":"RSS","friendlyName":"RSS-54-C\n","gpsHash":"gcnhyzz5du23","status":"Active"},{"hostName":"umbrella-d5dfe752","nodeType":"RSS","friendlyName":"RSS-A-33-C\n","gpsHash":"gcnhzx32n93s","status":"Active"},{"hostName":"umbrella-d69adc56","nodeType":"RSS","friendlyName":"RSS-40-C\n","gpsHash":"gcnjp0n5u048","status":"Active"},{"hostName":"umbrella-d7c589aa","nodeType":"RSS","friendlyName":"RSS-A-13-C\n","gpsHash":"gcnhyzdxum9b","status":"Active"},{"hostName":"umbrella-d9d5f9c3","nodeType":"RSS","friendlyName":"RSS-18-C\n","gpsHash":"gcnjp0jsshe2","status":"Active"},{"hostName":"umbrella-db4d4369","nodeType":"RSE","friendlyName":"RSE-L-A-4-C\n","gpsHash":"gcnjp0hec66n","status":"Active"},{"hostName":"umbrella-e0d46c0d","nodeType":"RSE","friendlyName":"RSE-A-14-C\n","gpsHash":"gcnhzx2ugq90","status":"Active"},{"hostName":"umbrella-e8416ad1","nodeType":"RSE","friendlyName":"RSE-L-3-C\n","gpsHash":"gcnhyzg01kps","status":"Active"},{"hostName":"umbrella-e98cd2c2","nodeType":"RSS","friendlyName":"RSS-11-C\n","gpsHash":"gcnjn80w3hmg","status":"Active"},{"hostName":"umbrella-eb04ab5c","nodeType":"RSE","friendlyName":"RSE-50-C\n","gpsHash":"gcnhyzc6ft5b","status":"Active"},{"hostName":"umbrella-ef7b5219","nodeType":"RSS","friendlyName":"RSS-21-C\n","gpsHash":"gcnhyxvpp8hq","status":"Active"},{"hostName":"umbrella-f20e2476","nodeType":"RSS","friendlyName":"RSS-17-C\n","gpsHash":"gcnhyxyub4y0","status":"Active"},{"hostName":"umbrella-f5cd1122","nodeType":"RSE","friendlyName":"RSE-16-C\n","gpsHash":"gcnjp04905je","status":"Active"},{"hostName":"umbrella-f5d800b9","nodeType":"RSS","friendlyName":"RSS-58-C\n","gpsHash":"gcnhyzy1mn46","status":"Active"},{"hostName":"umbrella-f6eecc93","nodeType":"RSS","friendlyName":"RSS-A-24-C\n","gpsHash":"gcnjp24yvf8r","status":"Active"},{"hostName":"umbrella-f76a17d7","nodeType":"RSS","friendlyName":"RSS-50-C\n","gpsHash":"gcnhyzet3sb2","status":"Active"},{"hostName":"umbrella-f82dc2a2","nodeType":"RSS","friendlyName":"RSS-28-C\n","gpsHash":"gcnjn0rm4dmh","status":"InActive"},{"hostName":"umbrella-f8684ec9","nodeType":"RSS","friendlyName":"RSS-A-25-C\n","gpsHash":"gcnhyp5ru95z","status":"InActive"},{"hostName":"umbrella-f92bce95","nodeType":"RSE","friendlyName":"RSE-A-17-C\n","gpsHash":"gcnhyzy7xscg","status":"Active"},{"hostName":"umbrella-fbf8f7eb","nodeType":"RSE","friendlyName":"RSE-22-C\n","gpsHash":"gcnjp0nt2vw6","status":"Active"},{"hostName":"umbrella-fe20e898","nodeType":"RSS","friendlyName":"RSS-15-C\n","gpsHash":"gcnhyzcdp8ey","status":"Active"}]}}
						let obj = response;
						let nodesSorted = obj.data.nodes.sort((a, b) => (a.status > b.status) ? 1 : ((b.status > a.status) ? -1 : 0));
						// console.log(nodesSorted)
						obj.data.nodes = nodesSorted;
						setExpNodes(obj)
						fetchExperiments();
					}, 200)
				})
				.catch((err) => {
					// console.log(err);
					fetchExperiments();
				});
		}


	}

	//To fetch eperiments after creation
	function changeStatus() {
		// console.log("Change Status Function")
		setTimeout(() => {
			fetchProject();
		}, 200);

	}

	//Code to check pending scanned files every 30 seconds
	function checkImageStatus(data) {
		// console.log(data);
		if (data.length > 0) {
			data.map((item, index) => {
				if (item.scanOverview.completePercent < 100) {
					const timer = setTimeout(() => {
						fetchImages()
					}, 30000);
					return () => clearTimeout(timer)
				}
			})

		}
		//commenting this logic and implementing seperate logic for not showing high severity images
		//checkImageSeverity(data);
	}

	//Code to check Image File Severity and add to state
	function checkImageSeverity(data) {
		// console.log(data)
		if (data.length > 0) {
			let sortedimages = [];

			data.map((item) => {
				// console.log("Image Name " + item.name , "severity " + item.scanOverview.severity);
				// if(item.scanOverview.severity == 'Low' || item.scanOverview.severity == 'None' || item.scanOverview.severity == 'Unknown'){
				// 	sortedimages.push(item)
				// }
				let chks = item.scanOverview.severity;
				if (chks !== 'Critical' && chks !== 'High') {
					sortedimages.push(item)
				}
			})
			setimgFileSeverity(sortedimages)
		}

	}

	//Code to convert GPs Hash to location and adding required data to original json
	function convertGeohash(input) {
		let oldData = input
		// console.log(oldData.data.nodes)
		for (let i = 0; i < oldData.data.nodes.length; i++) {
			const locationSlice = oldData.data.nodes[i].gpsHash
			if (locationSlice !== null && locationSlice !== '') {
				const res = locationSlice.slice(0, 9)
				const latlon = Geohash.decode(`${res}`)
				let obj = oldData.data.nodes[i];
				Object.assign(obj, { lat: parseFloat(latlon.lat), lng: parseFloat(latlon.lon), selected: false });
			} else {
				let obj = oldData.data.nodes[i];
				Object.assign(obj, { lat: 51.5074, lng: 0.1278, selected: false });
			}

		}

		setNodeList(oldData)
	}

	//Code to change Selected Node status
	function selectedNode(e) {
		let { checked } = e.target
		let nodeid = e.target.getAttribute('index');
		let hostname = e.target.getAttribute('hostname');
		// console.log(nodeid)
		let items = nodeList.data.nodes.map((row, index) => {
			// if (index == nodeid) {
			// 	row['selected'] = checked;   
			// }
			if (row["hostName"] == hostname) {
				row['selected'] = checked;
			}
			return row
		});

		setNodeList((prevState) => {
			prevState.data.nodes = items;
			return {
				...prevState
			};
		});

	}

	//Code to sort Experiment Data Completed / Archived
	function experimentListSort(data) {
		// console.log(data)
		let expCompleted = [];
		let expArchived = [];

		data.map((item) => {
			if (item.archived == true) {
				expArchived.push(item)
			} else {
				expCompleted.push(item)
			}
		})
		expCompleted.sort(function (a, b) {
			return a.creationTime - b.creationTime;
		});

		expArchived.sort(function (a, b) {
			return a.creationTime - b.creationTime;
		});
		setExperiments(expCompleted);
		setArchiveExperiments(expArchived);

	}

	const StyledBreadcrumb = styled(Chip)(({ theme }) => {
		const backgroundColor =
			theme.palette.mode === 'light'
				? theme.palette.grey[100]
				: theme.palette.grey[800];
		return {
			backgroundColor,
			height: theme.spacing(3),
			color: theme.palette.text.primary,
			fontWeight: theme.typography.fontWeightRegular,
			fontSize: '13px',
			'&:hover, &:focus': {
				backgroundColor: emphasize(backgroundColor, 0.06),
			},
			'&:active': {
				boxShadow: theme.shadows[1],
				backgroundColor: emphasize(backgroundColor, 0.12),
			},
		};
	});

	return (
		<Layout>
			<Stack spacing={2}>
				<Breadcrumbs
					separator={<NavigateNextIcon fontSize="small" />}
					aria-label="breadcrumb"
				>
					<Link to={`/projects`} underline="hover" key="1" color="text.primary">
						<StyledBreadcrumb
							component="a"
							href="/projects"
							label="My Projects"
							icon={<FolderIcon fontSize="medium" style={{ color: "#1c7b8e" }} />}
						/>
					</Link>
					<Typography key="2" color="text.primary">
						<ListIcon style={{ color: "#1c7b8e" }} fontSize="medium" />{projectInfo.projectName}
					</Typography>
				</Breadcrumbs>
			</Stack>
			<div
				className=" col-md-12 col-sm-12 col-lg-12 text-left"
				style={{ margin: '2rem 2.5rem' }}
			>
				<label className="create-proj-text-color">
					<b>Project Details</b>
				</label>
				<Jumbotron
					className="bg-white"
					style={{ marginRight: '5rem', padding: '1rem 2rem' }}
				>

					<TableContainer>
						<Table aria-label="simple table">
							<TableBody>
								<TableRow >
									<TableCell>
										Project Name
									</TableCell>
									<TableCell align="left">{projectInfo.projectName}</TableCell>
								</TableRow>
								<TableRow >
									<TableCell >
										Project Id
									</TableCell>
									<TableCell align="left">{projectInfo.projectId}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>
										Project Description
									</TableCell>
									<TableCell align="left">{projectInfo.projectDescription}</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</Jumbotron>

				<br />
				<label className="create-proj-text-color">
					<b>Network</b>
				</label>
				{
					Object.keys(nodeList).length > 0 ? (
						<>
							<NetworkNodes projectId={match.params.id} nodelist={nodeList} nodeselect={(e) => selectedNode(e)} />
						</>
					) : (
						<>
							<p>Network data loading . . . </p>
						</>
					)
				}

				<br />

				<label className="create-proj-text-color">
					<b>Files</b>
				</label>
				<Jumbotron
					className="bg-white"
					style={{ marginRight: '5rem', padding: '1rem 2rem' }}
				>
					{getImages.length > 0 || getBinaries.length > 0 ? (
						<FilesTable images={getImages} binaries={getBinaries} parentProp={match} changeCurState={(e) => changeStatus(e)} projectrole={projectRole} />
					) : (
						<>
							{filesList.length == 0 ? (

								<h4 className="create-proj-jumbo" style={{ textAlign: 'center' }}>
									You don't have any files uploaded to this project.
								</h4>
							) : (
								<>

								</>
							)}
						</>
					)}

					{
						projectRole == 'developer' || projectRole == 'projectAdmin' ? (
							<>
								<div>
									<div className="upload-btn-wrapper">
										<Button className="btnDefault" onClick={onImageFileChange}>+ Add Images</Button>
									</div>
									<br />
									<div id="unImgUpload" style={{ display: 'none' }}>
										{/* {imageManager === true ? <ImageUploader projectid={match.params.id} changeCurState={(e) => changeStatus(e)} /> : null} */}
										<ImageUploader projectid={match.params.id} changeCurState={(e) => changeStatus(e)} />
									</div>
									<div className="upload-btn-wrapper" style={{ marginTop: '1%' }}>
										<Button className="btnDefault" onClick={onBinaryFileChange}>+ Add Binares</Button>
									</div>
									<br />
									<div id="binImgUpload" style={{ display: 'none' }}>
										{/* {binaryManager === true ? <BinaryUploader projectid={match.params.id} changeCurState={(e) => changeStatus(e)} /> : null} */}
										<BinaryUploader projectid={match.params.id} changeCurState={(e) => changeStatus(e)} />
									</div>
								</div>
							</>
						) : null
					}

				</Jumbotron>
				<br />
				<TabContext value={value}>
					<Box sx={{ borderBottom: 0, borderColor: 'white'  }}>
						<TabList onChange={handleChange} aria-label="lab API tabs example">
							<Tab label="Experiments" value="1" />
							<Tab label="Archives" value="2" />
						</TabList>
					</Box>
					<TabPanel value="1">
					<Jumbotron className="text-center bg-white " style={{ marginRight: '5rem' }}>
							{experiments.length > 0 ? (
								<div className="">
									<ExperimentTable data={experiments} project={projectInfo} changeCurState={(e) => changeStatus(e)} projectrole={projectRole} />
									<div className="col-md-12 text-right no-padding">

										{/* {Object.keys( expNodes ).length > 0 && getImages.length > 0 ?  */}
										{
											projectRole == 'developer' || projectRole == 'projectAdmin' ? (
												<>
													{getImages.length > 0 || getBinaries.length > 0 ?
														<CreateExperiment
															project_id={match.params.id}
															images={getImages}
															binaries={getBinaries}
															nodelist={expNodes}
															changeCurState={(e) => changeStatus(e)}
														/>
														:
														<Button className="btnDefault" disabled>
															Create Experiment
														</Button>
													}
												</>
											) : null
										}
									</div>
								</div>
							) : (
								<>
									<h4 className="create-proj-jumbo">
										You don't have any experiments to this project.
									</h4>
									{
										projectRole == 'developer' || projectRole == 'projectAdmin' ? (
											<>
												{getImages.length > 0 || getBinaries.length > 0 ?
													<CreateExperiment
														project_id={match.params.id}
														images={getImages}
														binaries={getBinaries}
														nodelist={expNodes}
														changeCurState={(e) => changeStatus(e)}
													/>
													:
													<Button className="btnDefault" disabled>
														Create Experiment
													</Button>
												}
											</>
										) : null
									}
								</>
							)}
						</Jumbotron>
					</TabPanel>
					<TabPanel value="2">
					<Jumbotron className="text-center bg-white " style={{ marginRight: '5rem' }}>
							{archiveExperiments.length > 0 ? (
								<div className="">
									<ExperimentArchiveTable data={archiveExperiments} project={projectInfo} changeCurState={(e) => changeStatus(e)} projectrole={projectRole} />
								</div>
							) : (
								<>
									<h4 className="create-proj-jumbo">
										You don't have any archived experiments to this project.
									</h4>
								</>
							)}
						</Jumbotron>
					</TabPanel>
				</TabContext>			
				<br />
				{
					projectRole == 'projectAdmin' ? (
						<>
							<Jumbotron
								className="bg-white"
								style={{ marginRight: '5rem', padding: '0' }}
							>
								<AddUpdateUsers projectid={match.params.id} />
							</Jumbotron>
						</>
					) : null
				}
				<br />
			</div>
			<ToastContainer draggable={false} transition={Zoom} />
		</Layout>
	);
};

export default Project;
